/* Code by convx - 984. Empty-search panel, rollout of A/B test #704.
 * The panel markup is rendered by snippets/cvx-search-empty.liquid. This only
 * shows it while the search box is open and empty, and hides it on typing so
 * predictive search takes over. The header renders the search box twice
 * (desktop + mobile), so every <search-engine> gets its own instance. */
(function () {
  'use strict';

  if (window.cvxSearchEmptyLoaded) return;
  window.cvxSearchEmptyLoaded = true;

  var instances = [];

  function isEmpty(input) {
    return !input.value || !input.value.trim();
  }

  function show(inst) {
    if (inst.open || !isEmpty(inst.input)) return;
    inst.panel.classList.add('cvx-se-open');
    inst.host.classList.add('cvx-se-open-host');
    inst.input.setAttribute('aria-expanded', 'true');
    inst.open = true;
  }

  function hide(inst) {
    if (!inst.open) return;
    inst.panel.classList.remove('cvx-se-open');
    inst.host.classList.remove('cvx-se-open-host');
    inst.input.setAttribute('aria-expanded', 'false');
    inst.open = false;
  }

  function setup(engine) {
    var panel = engine.querySelector('[data-cvx-se-panel]');
    var input = engine.querySelector('input[type="search"][name="q"]');
    if (!panel || !input) return;

    var inst = {
      engine: engine,
      panel: panel,
      input: input,
      host: engine.querySelector('.search-section') || engine,
      open: false
    };
    instances.push(inst);

    input.addEventListener('focus', function () { show(inst); });
    input.addEventListener('input', function () {
      if (isEmpty(input)) show(inst); else hide(inst);
    });
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') hide(inst);
    });

    var form = engine.querySelector('form');
    if (form) {
      form.addEventListener('reset', function () {
        setTimeout(function () { show(inst); }, 0);
      });
    }
  }

  function openInside(node) {
    for (var i = 0; i < instances.length; i++) {
      if (node.contains(instances[i].engine)) show(instances[i]);
    }
  }

  /* Code by Ruby - convx - 1086. drag-and-scroll for the category row */
  function initDragScroll() {
    var track = null, startX = 0, startLeft = 0, moved = false;

    document.addEventListener('mousedown', function (event) {
      moved = false;
      if (event.button !== 0 || !event.target.closest) return;
      var el = event.target.closest('.cvx-se-cats');
      if (!el || el.scrollWidth <= el.clientWidth) return;
      track = el;
      startX = event.pageX;
      startLeft = el.scrollLeft;
    });

    document.addEventListener('mousemove', function (event) {
      if (!track) return;
      var dx = event.pageX - startX;
      if (!moved && Math.abs(dx) > 5) {
        moved = true;
        track.classList.add('cvx-se-dragging');
      }
      if (moved) {
        track.scrollLeft = startLeft - dx;
        event.preventDefault();
      }
    });

    function end() {
      if (!track) return;
      track.classList.remove('cvx-se-dragging');
      track = null;
    }
    document.addEventListener('mouseup', end);
    window.addEventListener('blur', end);

    document.addEventListener('click', function (event) {
      if (!moved) return;
      moved = false;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  }
  /* End of 1086 */


  function init() {
    var engines = document.querySelectorAll('search-engine');
    for (var i = 0; i < engines.length; i++) setup(engines[i]);
    if (!instances.length) return;

    // Code by Ruby - convx - 1086
    initDragScroll();
    // End of 1086

    // Close on a click anywhere outside the open search box.
    document.addEventListener('click', function (event) {
      for (var j = 0; j < instances.length; j++) {
        if (instances[j].open && !instances[j].engine.contains(event.target)) hide(instances[j]);
      }
    }, true);

    // Open as soon as the header search opens, before the input is touched.
    document.addEventListener('click', function (event) {
      if (!event.target.closest || !event.target.closest('.search-mobile-icon, .fire-search, [data-open-search]')) return;
      setTimeout(function () {
        var wrapper = document.querySelector('.search.active');
        if (wrapper) openInside(wrapper);
      }, 0);
    });

    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        for (var k = 0; k < records.length; k++) {
          var node = records[k].target;
          if (node.classList && node.classList.contains('search') && node.classList.contains('active')) openInside(node);
        }
      }).observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
